import { useState, useEffect } from "react";
import apiClient from "./api/client";

const styles = `
  @import url('https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css');

  * { box-sizing: border-box; }

  /* Base improvements */
  .stats { 
    display: grid; 
    grid-template-columns: repeat(5, 1fr); 
    gap: 12px; 
    margin-bottom: 20px; 
  }

  .sc { 
    background: #fff; 
    border-radius: 10px; 
    padding: 16px 14px 12px; 
    box-shadow: 0 1px 4px rgba(60,179,119,.1); 
    transition: transform .18s; 
  }
  .sc:hover { transform: translateY(-2px); }

  .si { 
    width: 38px; 
    height: 38px; 
    border-radius: 9px; 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    font-size: 17px; 
    margin-bottom: 8px; 
  }
  .sv { 
    font-size: 24px; 
    font-weight: 700; 
    color: #1a2e22; 
    margin: 0; 
    line-height: 1.1; 
  }
  .sl { 
    font-size: 11px; 
    color: #6b7c74; 
    margin: 4px 0 0; 
    font-weight: 600; 
    text-transform: uppercase; 
    letter-spacing: .4px; 
  }

  /* Mid section */
  .mid { 
    display: grid; 
    grid-template-columns: 1fr 320px; 
    gap: 16px; 
    margin-bottom: 20px; 
    min-width: 0; 
  }

  .sec { 
    background: #fff; 
    border-radius: 10px; 
    padding: 16px; 
    box-shadow: 0 1px 4px rgba(60,179,119,.07); 
    min-width: 0; 
    overflow: visible; 
  }
  .sec-hdr { 
    display: flex; 
    align-items: center; 
    justify-content: space-between; 
    margin-bottom: 12px; 
    flex-wrap: wrap; 
    gap: 8px; 
  }
  .sec-title { 
    font-size: 14px; 
    font-weight: 600; 
    color: #1a2e22; 
    margin: 0; 
    display: flex; 
    align-items: center; 
    gap: 6px; 
  }

  .va { 
    font-size: 12px; 
    font-weight: 500; 
    color: #0aa375; 
    background: none; 
    border: none; 
    cursor: pointer; 
    display: flex; 
    align-items: center; 
    gap: 4px; 
    padding: 6px 10px; 
    border-radius: 6px; 
  }
  .va:hover { background: #e1f5ee; }

  /* Tables */
  table { 
    width: 100%; 
    border-collapse: collapse; 
    font-size: 13px; 
    min-width: 620px; 
  }
  table th, table td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
  }
  th { 
    text-align: left; 
    padding: 8px 10px; 
    color: #6b7c74; 
    font-size: 11px; 
    font-weight: 600; 
    text-transform: uppercase; 
    letter-spacing: .3px; 
    border-bottom: 2px solid #e8f5ee; 
  }
  td { 
    padding: 10px 10px; 
    color: #2c3e36; 
    border-bottom: 1px solid #f0f7f3; 
    vertical-align: middle; 
  }
  tr:hover td { background: #f7fdf9; }

  .tid, .tsubj, .tacct { white-space: normal; word-break: break-word; }

  /* Badges */
  .badge { 
    display: inline-flex; 
    align-items: center; 
    padding: 3px 8px; 
    border-radius: 20px; 
    font-size: 11px; 
    font-weight: 600; 
    white-space: nowrap; 
  }
  .bt { background:#e1f5ee; color:#0f6e56; }
  .br { background:#fcebeb; color:#a32d2d; }

  /* Quick Actions */
  .qa-sec { 
    background: #fff; 
    border-radius: 10px; 
    padding: 16px; 
    box-shadow: 0 1px 4px rgba(60,179,119,.07); 
    width: 100%; 
  }
  .qa-grid { 
    display: grid; 
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)); 
    gap: 12px; 
    margin-top: 12px; 
  }
  .qa-card { 
    display: flex; 
    align-items: center; 
    padding: 11px 14px; 
    border-radius: 8px; 
    cursor: pointer; 
    border: 1px solid #e1f5ee; 
    background: #ffffff; 
    transition: all .15s ease; 
    text-align: left; 
    min-height: 56px; 
  }
  .qa-card:hover { 
    background: #f7fdf9; 
    transform: translateY(-2px); 
    box-shadow: 0 3px 9px rgba(60,179,119,.14); 
  }

  /* Recent Logs */
  .recent-logs-container { 
    max-height: 320px; 
    overflow-y: auto; 
    padding-right: 8px; 
  }
  .recent-log-card { 
    background: #f8fdfa; 
    border-radius: 8px; 
    padding: 12px 14px; 
    border: 1px solid #e1f5ee; 
    margin-bottom: 10px; 
  }

  /* ====================== RESPONSIVE ====================== */
  @media (max-width: 1024px) {
    .mid { grid-template-columns: 1fr; }
    table { font-size: 12.5px; }
  }

  @media (max-width: 768px) {
    .stats { gap: 10px; }
    .sc { padding: 14px 12px 10px; }
    .sv { font-size: 21px; }
    .sec { padding: 14px; }
    .qa-grid { grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); }
    .qa-card { min-height: 60px; padding: 12px 14px; }
  }

  @media (max-width: 480px) {
    .stats { grid-template-columns: 1fr; }
    table { font-size: 12px; }
    th, td { padding: 8px 6px; }
    .qa-grid { grid-template-columns: 1fr; }
  }

  .sec-hdr {
    gap: 12px;
  }

  .recent-log-domain {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    .va {
      padding: 5px 9px;
      font-size: 11.5px;
    }
  }
`;

function Badge({ type, children }) {
  return <span className={`badge ${type}`}>{children}</span>;
}

function StatCard({ borderColor, iconBg, iconColor, iconClass, value, label, onClick }) {
  return (
    <div className="sc" style={{ borderTop: `3px solid ${borderColor}` }} onClick={onClick}>
      <div className="si" style={{ background: iconBg, color: iconColor }}>
        <i className={`ti ${iconClass}`} aria-hidden="true" />
      </div>
      <p className="sv">{value}</p>
      <p className="sl">{label}</p>
    </div>
  );
}

function TicketRow({ ticketNumber, subject, account, priority, status, subStatus }) {
  return (
    <tr>
      <td><span className="tid">{ticketNumber}</span></td>
      <td className="tsubj">{subject}</td>
      <td className="tacct">{account}</td>
      <td><Badge type="br">{priority}</Badge></td>
      <td><Badge type="bt">{status}</Badge></td>
      <td><Badge type="bt">{subStatus || '—'}</Badge></td>
    </tr>
  );
}

const RecentLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    const fetchRecentLogs = async () => {
      setLoading(true);
      setError(false);

      try {
        const userRoleId = sessionStorage.getItem("userRoleId");
        const userId = sessionStorage.getItem("userId");
        const isSuperAdmin = userRoleId === "1" || userRoleId === 1;
        const params = {};
        if (!isSuperAdmin && userId) {
          params.userId = userId;
        }
        const res = await apiClient.get('/api/logs/generallog/recent', { params });
        setLogs(res.data?.logs || []);
      } catch (err) {
        console.error("Failed to fetch recent logs:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentLogs();
  }, []);

  if (loading) return <div className="qa-loading">Loading recent logs…</div>;
  if (error) return <div className="qa-empty">Failed to load recent logs.</div>;
  if (logs.length === 0) return <div className="qa-empty">No recent activity.</div>;

  return (
    <>
      <div className="recent-logs-container">
        {logs.map((log, i) => {
          const isFailed = log.activity?.toUpperCase().includes("[FAILED]");
          return (
            <div className="recent-log-card" key={i}>
              <div className="recent-log-header" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Badge type={isFailed ? "br" : "bt"}>
                    {isFailed ? "Failed" : "Success"}
                  </Badge>
                  <span className="recent-log-domain">{log.domain || "—"}</span>
                </div>
                <button 
                  className="va recent-log-view" 
                  onClick={() => setSelectedLog(log)}
                >
                  View
                </button>
              </div>
              <div className="recent-log-info">
                <span className="recent-log-user">
                  <i className="ti ti-user" aria-hidden="true" /> {log.userName || "—"}
                </span>
                <span className="recent-log-time">
                  {log.timestamp ? new Date(log.timestamp).toLocaleString() : ""}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {selectedLog && (
        <div 
          style={{ 
            position: 'fixed', 
            inset: 0, 
            background: 'rgba(0,0,0,0.8)', 
            zIndex: 10000, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '12px'
          }} 
          onClick={() => setSelectedLog(null)}
        >
          <div 
            style={{ 
              background: 'white', 
              width: '90%', 
              maxWidth: '700px', 
              maxHeight: '85vh', 
              borderRadius: '12px', 
              overflow: 'hidden',
              boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
            }} 
            onClick={e => e.stopPropagation()}
          >
            <div style={{ 
              padding: '10px 20px', 
              background: '#0aa375', 
              color: 'white', 
              display: 'flex', 
              justifyContent: 'space-between',               
              alignItems: 'center',
              minHeight: '48px',
              fontSize: '14px',
              fontWeight: '600'            
              }}>
              <h4 style={{ margin: 0 }}>Log Details</h4>
              <button 
                onClick={() => setSelectedLog(null)} 
                style={{ fontSize: '28px', background: 'none', border: 'none', color: 'white' }}
              >
                ×
              </button>
            </div>

            <div style={{ padding: '20px', fontSize: '13px', lineHeight: '1.6' }}>              
              <div style={{ marginBottom: '12px' }}>
                <strong>Source:</strong> {selectedLog.source || "—"}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <strong>Activity:</strong>
              </div>
              <pre style={{ 
                background: '#f8fdfa', 
                padding: '14px', 
                borderRadius: '8px', 
                border: '1px solid #e1f5ee',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '12.5px',
                overflow: 'auto',
                maxHeight: '400px'
              }}>
                {selectedLog.activity || "No details available"}
              </pre>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default function DashboardHome({
  username = "User",
  domain,
  onViewAllTickets,
  onViewAllImports,
  onQuickAction,
  onRegisteredUsersClick
}) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showOpenTickets, setShowOpenTickets] = useState(false);
  const [showCompanies, setShowCompanies] = useState(false);

  const [quickActions, setQuickActions] = useState([]);
  const [qaLoading, setQaLoading] = useState(true);

  useEffect(() => {
    const loadDashboard = async () => {
      if (!domain) return;
      setLoading(true);
      try {
        const res = await apiClient.post('/api/dashboard/stats', { domain });
        setStats(res.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load dashboard");
      } finally {
        setLoading(false);
      }
    };
    loadDashboard();
  }, [domain]);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId") || sessionStorage.getItem("userRoleId");
    if (!userId) {
      setQaLoading(false);
      return;
    }
    const fetchFavorites = async () => {
      try {
        const res = await apiClient.get(`/api/admin/favorites/${userId}`);
        const data = (res.data || []).filter(f => f.isFavourite === true || f.IsFavourite === true);
        const actions = data.map(fav => ({
          label: fav.displayName || fav.DisplayName || fav.menuName,
          menuName: fav.menuName || fav.MenuName,
          borderColor: "#5dcaa5"
        }));
        setQuickActions(actions);
      } catch (err) {
        console.error(err);
      } finally {
        setQaLoading(false);
      }
    };
    fetchFavorites();
  }, []);

  if (loading) return <div className="text-center py-5">Loading dashboard...</div>;
  if (error || !stats) return <div className="text-center py-5 text-danger">{error}</div>;

  return (
    <>
      <style>{styles}</style>
      <div style={{ 
        padding: "20px 16px 30px", 
        background: "#f0faf5", 
        fontFamily: "'Segoe UI', system-ui, sans-serif", 
        width: "100%", 
        minWidth: 0, 
        overflowX: "hidden",
        maxWidth: "100%"
      }}>
        <div className="stats">
          <StatCard 
            borderColor="#85b7eb" iconBg="#e6f1fb" iconColor="#185fa5" iconClass="ti-ticket"
            value={stats.openTickets} label="Open Tickets" onClick={() => setShowOpenTickets(true)}
          />
          <StatCard 
            borderColor="#afa9ec" iconBg="#eeedfe" iconColor="#534ab7" iconClass="ti-users"
            value={stats.registeredUsers} label="Registered Users" 
            onClick={onRegisteredUsersClick}
          />
          <StatCard 
            borderColor="#ef9f27" iconBg="#faeeda" iconColor="#854f0b" iconClass="ti-building"
            value={stats.activeCompanies} label="Active Companies" onClick={() => setShowCompanies(true)}
          />
        </div>

        <div className="mid">
          <div className="sec">
            <div className="sec-hdr">
              <h2 className="sec-title">
                <i className="ti ti-ticket" aria-hidden="true" /> Recent Tickets
              </h2>
              <button className="va" onClick={onViewAllTickets}>
                View all <i className="ti ti-arrow-right" aria-hidden="true" />
              </button>
            </div>
            <div style={{ overflowX: "auto", borderRadius: "8px", border: "1px solid #e8f5ee" }}>
              {/* Desktop Table */}
              <table className="table table-hover mb-0 tbl-compact d-none d-md-table" style={{ tableLayout: 'fixed', minWidth: '620px' }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Subject</th>
                    <th>Account</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Sub-status</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.recentTickets?.map(t => (
                    <TicketRow 
                      key={t.bgTicketId}
                      ticketNumber={t.ticketNumber}
                      subject={t.subject}
                      account={t.account}
                      priority={t.priority}
                      status={t.status}
                      subStatus={t.subStatus}
                    />
                  ))}
                </tbody>
              </table>

              {/*  Card View */}
              <div className="d-md-none">
                {stats.recentTickets?.map(t => (
                  <div key={t.bgTicketId} style={{
                    background: '#fff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    padding: '14px',
                    marginBottom: '12px',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                  }}>
                    <div style={{ fontWeight: 700, color: '#0aa375', marginBottom: '10px', fontSize: '15px' }}>
                      #{t.ticketNumber}
                    </div>

                    <div style={{ marginBottom: '8px' }}>
                      <strong style={{ fontSize: '13px' }}>SUBJECT:</strong> {t.subject}
                    </div>

                    <div style={{ marginBottom: '8px' }}>
                      <strong style={{ fontSize: '13px' }}>ACCOUNT:</strong> {t.account}
                    </div>

                    <div style={{ display: 'flex', gap: '20px', marginBottom: '8px' }}>
                      <div>
                        <strong style={{ fontSize: '13px' }}>PRIORITY:</strong> <Badge type="br">{t.priority}</Badge>
                      </div>
                      <div>
                        <strong style={{ fontSize: '13px' }}>STATUS:</strong> <Badge type="bt">{t.status}</Badge>
                      </div>
                    </div>

                    <div>
                      <strong style={{ fontSize: '13px' }}>SUB-STATUS:</strong> <Badge type="bt">{t.subStatus || '—'}</Badge>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="sec">
            <div className="sec-hdr">
              <h2 className="sec-title">
                <i className="ti ti-activity" aria-hidden="true" /> Recent Logs
              </h2>
            </div>
            <div style={{ fontSize: '12px' }}>
              <RecentLogs />
            </div>
          </div>
        </div>

        <div className="qa-sec">
          <div className="sec-hdr">
            <h2 className="sec-title">
              <i className="ti ti-grid-dots" aria-hidden="true" /> Quick Actions
            </h2>
          </div>

          {qaLoading ? (
            <div className="qa-loading">
              <i className="ti ti-loader-2" aria-hidden="true" />
              Loading quick actions…
            </div>
          ) : quickActions.length === 0 ? (
            <div className="qa-empty">
              <i className="ti ti-star-off" aria-hidden="true" />
              <p>No favourites added yet. Star a menu item to pin it here.</p>
            </div>
          ) : (
            <div className="qa-grid">
              {quickActions.map((qa, idx) => (
                <button
                  key={idx}
                  className="qa-card"
                  style={{ borderLeft: `3px solid ${qa.borderColor}` }}
                  onClick={() => onQuickAction?.(qa.menuName)}
                >
                  <div className="qt">
                    <span className="ql">{qa.label}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {showOpenTickets && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px' }}>
          <div style={{ background: 'white', width: '100%', maxWidth: '960px', maxHeight: '92vh', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px 24px', background: '#0aa375', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', fontWeight: '600', minHeight: '52px' }}>
              <h4 style={{ margin: 0 }}>Open Tickets</h4>
              <button onClick={() => setShowOpenTickets(false)} style={{ fontSize: '28px', background: 'none', border: 'none', color: 'white' }}>×</button>
            </div>
            <div style={{ padding: '16px', overflow: 'auto', flex: 1, fontSize: '12.5px' }}>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Subject</th>
                    <th>Account</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Sub-status</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.openTicketsList?.map(t => (
                    <TicketRow 
                      key={t.bgTicketId}
                      ticketNumber={t.ticketNumber}
                      subject={t.subject}
                      account={t.account}
                      priority={t.priority}
                      status={t.status}
                      subStatus={t.subStatus}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {showCompanies && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px' }}>
          <div style={{ background: 'white', width: '100%', maxWidth: '620px', maxHeight: '90vh', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px 24px', background: '#0aa375', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', fontWeight: '600', minHeight: '52px' }}>
              <h4 style={{ margin: 0 }}>Active Companies</h4>
              <button onClick={() => setShowCompanies(false)} style={{ fontSize: '28px', background: 'none', border: 'none', color: 'white' }}>×</button>
            </div>
            <div style={{ padding: '12px 16px', overflow: 'auto', flex: 1, fontSize: '12px' }}>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "30%", minWidth: "120px" }}>Company ID</th>
                    <th>Company Name</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.activeCompaniesList?.map((c, i) => (
                    <tr key={i}>
                      <td>{c.companyId}</td>
                      <td>{c.companyName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}